import { printer } from '@/utils/printer';
import { isElectronContext } from '../utils/isElectron';
import store from '@/store';

const storeSettings = getStoreSettings();

const isElectron = isElectronContext();

let MAC_ADDRESS = '';

export function getStoreSettings(){
  return store.state.settings;
}

export function tryGetMacAddress() {
  // Check if client is in Android Webview
  if (typeof Epos_Android_Interface != 'undefined') {
    if (Epos_Android_Interface.getMacAddress != 'undefined') {
      MAC_ADDRESS = Epos_Android_Interface.getAndroidDeviceMacAddress();

      return;
    }
  }

  // Check if client is in Electron
  // Use printer machine info?
  if (isElectron) {
    MAC_ADDRESS = printer.getMachineInfo();
    return;
  }

  // Finally, last option is the client is loaded in Web
  // if (process.env.NODE_ENV === 'development') {
  if (window.location.hostname === 'localhost') {
    // MAC_ADDRESS = "apueston.mx";
    // MAC_ADDRESS = "instabet.mx";
    MAC_ADDRESS = 'instabet.com';
    //MAC_ADDRESS = 'instabet.net';
    // MAC_ADDRESS = 'instabetcom.dev.notavailable.mx';
    return;
  }

  if (document.domain.includes('instabetmx-engine')) {
    MAC_ADDRESS = 'instabetmx.dev.notavailable.mx';
    return;
  }

  if (document.domain.includes('instabetnet-engine')) {
    MAC_ADDRESS = 'instabetnet.dev.notavailable.mx';
    return;
  }

  if (document.domain.includes('instabetcom-engine')) {
    MAC_ADDRESS = 'instabetcom.dev.notavailable.mx';
    return;
  }

  if (document.domain.includes('engine-dev.instabet.mx')) {
    MAC_ADDRESS = 'engine.instabet.mx';
    return;
  }
  if (document.domain === 'ib-engine.instabet.com') {
    MAC_ADDRESS = 'instabet.com';
    return;
  }

  if (window.location.hostname.startsWith('engine-stg')) {
    MAC_ADDRESS = window.location.hostname.replace('engine-stg.', '');
    return;
  }

  if (window.location.hostname.startsWith('engine-dev')) {
    MAC_ADDRESS = window.location.hostname.replace('engine-dev.', '');
    return;
  }

  if (window.location.hostname.startsWith('engine-qa')) {
    MAC_ADDRESS = window.location.hostname.replace('engine-qa.', '');
    return;
  }

  if (window.location.hostname.startsWith('engine-preprod')) {
    MAC_ADDRESS = window.location.hostname.replace('engine-preprod.', '');
    return;
  }

  if (window.location.hostname.startsWith('instabet-engine-fv3')) {
    MAC_ADDRESS = 'instabet.mx';
    return;
  }

 if (window.location.hostname.includes('aim-test')) {
    MAC_ADDRESS = 'instabet.mx';
    return;
  }

  if (window.location.hostname.includes('aim.software')) {
    MAC_ADDRESS = 'instabet.mx';
    return;
  }


  MAC_ADDRESS =
    (window.location.hostname.indexOf('www.') && window.location.hostname) ||
    window.location.hostname.replace('www.', '');
}

// export MAC_ADDRESS for settings.js file
export function getDeviceMacAddress() {
  if (storeSettings && storeSettings.macAddress && storeSettings.isScanningCodeForMobile) {
    MAC_ADDRESS = storeSettings.macAddress;
  }

  if (!MAC_ADDRESS) tryGetMacAddress();
  MAC_ADDRESS = MAC_ADDRESS.replace('engine.', '');
  return MAC_ADDRESS;
}
